import styled from "@emotion/styled"

const ArticleRelatedArticleInfoNotice = styled.span`
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 27px;
`

export default ArticleRelatedArticleInfoNotice